(function () {
    'use strict';

    angular
        .module('franchisee-portal.filters')
        .filter('momentIsBetween', momentIsBetween)

    function momentIsBetween() {
        function momentIsBetweenFn(startValue, endValue) {
            moment.locale('pt-br');

            var dateStart;
            var dateEnd;

            if (!startValue || !endValue)
                return '';

            dateStart = moment(startValue);
            dateEnd = moment(endValue);

            if (!dateStart.isValid() || !dateEnd.isValid())
                return '';

            return moment().isBetween(dateStart, dateEnd, null, '[]');
        }

        return momentIsBetweenFn;
    }
}());